<template>
  <v-container class="pt-0 mt-0">
    <v-row>
      <v-spacer />
      <v-col cols="10">
        <user-form />
      </v-col>
      <v-spacer />
    </v-row>

    <v-row>
      <v-spacer />
      <v-col cols="10"> </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import UserForm from "../components/UserForm";

export default {
  name: "Register",
  components: {
    "user-form": UserForm,
  },
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}
</style>
